// Updated industries for Mixrank Data
export const CiroInternalIndustries = [
  {
    label: "IT Services and IT Consulting",
    countCompanies: 1647711,
  },
  {
    label: "Construction",
    countCompanies: 1612755,
  },
  {
    label: "Business Consulting and Services",
    countCompanies: 1337619,
  },
  {
    label: "Retail",
    countCompanies: 1262651,
  },
  {
    label: "Advertising Services",
    countCompanies: 1174675,
  },
  {
    label: "Real Estate",
    countCompanies: 1159524,
  },
  {
    label: "Software Development",
    countCompanies: 1050077,
  },
  {
    label: "Medical Practices",
    countCompanies: 809442,
  },
  {
    label: "Financial Services",
    countCompanies: 779485,
  },
  {
    label: "Technology, Information and Internet",
    countCompanies: 760761,
  },
  {
    label: "Restaurants",
    countCompanies: 700001,
  },
  {
    label: "Hospitals and Health Care",
    countCompanies: 684134,
  },
  {
    label: "Wellness and Fitness Services",
    countCompanies: 656832,
  },
  {
    label: "Design Services",
    countCompanies: 594317,
  },
  {
    label: "Non-profit Organizations",
    countCompanies: 540400,
  },
  {
    label: "Individual and Family Services",
    countCompanies: 508829,
  },
  {
    label: "Hospitality",
    countCompanies: 485300,
  },
  {
    label: "Professional Training and Coaching",
    countCompanies: 437771,
  },
  {
    label: "Appliances, Electrical, and Electronics Manufacturing",
    countCompanies: 436703,
  },
  {
    label: "Food and Beverage Services",
    countCompanies: 421702,
  },
  {
    label: "Motor Vehicle Manufacturing",
    countCompanies: 416090,
  },
  {
    label: "Education Administration Programs",
    countCompanies: 405743,
  },
  {
    label: "Accounting",
    countCompanies: 394157,
  },
  {
    label: "Consumer Services",
    countCompanies: 393461,
  },
  {
    label: "Wholesale",
    countCompanies: 370163,
  },
  {
    label: "Civic and Social Organizations",
    countCompanies: 355924,
  },
  {
    label: "Marketing Services",
    countCompanies: 345824,
  },
  {
    label: "Architecture and Planning",
    countCompanies: 344921,
  },
  {
    label: "Higher Education",
    countCompanies: 337196,
  },
  {
    label: "Retail Apparel and Fashion",
    countCompanies: 336801,
  },
  {
    label: "Truck Transportation",
    countCompanies: 330513,
  },
  {
    label: "Entertainment Providers",
    countCompanies: 329176,
  },
  {
    label: "Spectator Sports",
    countCompanies: 328715,
  },
  {
    label: "Industrial Machinery Manufacturing",
    countCompanies: 311825,
  },
  {
    label: "Insurance",
    countCompanies: 309585,
  },
  {
    label: "Legal Services",
    countCompanies: 309168,
  },
  {
    label: "Manufacturing",
    countCompanies: 307835,
  },
  {
    label: "Events Services",
    countCompanies: 305916,
  },
  {
    label: "Machinery Manufacturing",
    countCompanies: 304835,
  },
  {
    label: "Travel Arrangements",
    countCompanies: 294851,
  },
  {
    label: "Human Resources Services",
    countCompanies: 291965,
  },
  {
    label: "Staffing and Recruiting",
    countCompanies: 289365,
  },
  {
    label: "Media Production",
    countCompanies: 287373,
  },
  {
    label: "Food and Beverage Manufacturing",
    countCompanies: 280325,
  },
  {
    label: "Law Practice",
    countCompanies: 279834,
  },
  {
    label: "Information Technology and Services",
    countCompanies: 271528,
  },
  {
    label: "Research Services",
    countCompanies: 267047,
  },
  {
    label: "Facilities Services",
    countCompanies: 244366,
  },
  {
    label: "Environmental Services",
    countCompanies: 228245,
  },
  {
    label: "Transportation, Logistics, Supply Chain and Storage",
    countCompanies: 227003,
  },
  {
    label: "Telecommunications",
    countCompanies: 223497,
  },
  {
    label: "Education",
    countCompanies: 217749,
  },
  {
    label: "Mining",
    countCompanies: 212151,
  },
  {
    label: "E-Learning Providers",
    countCompanies: 205015,
  },
  {
    label: "Book and Periodical Publishing",
    countCompanies: 202450,
  },
  {
    label: "Oil and Gas",
    countCompanies: 198864,
  },
  {
    label: "Photography",
    countCompanies: 195390,
  },
  {
    label: "Graphic Design",
    countCompanies: 194391,
  },
  {
    label: "Farming",
    countCompanies: 181951,
  },
  {
    label: "Venture Capital and Private Equity Principals",
    countCompanies: 180415,
  },
  {
    label: "Musicians",
    countCompanies: 178398,
  },
  {
    label: "Retail Office Equipment",
    countCompanies: 177615,
  },
  {
    label: "Wholesale Building Materials",
    countCompanies: 176224,
  },
  {
    label: "Investment Management",
    countCompanies: 176206,
  },
  {
    label: "Government Administration",
    countCompanies: 176158,
  },
  {
    label: "Furniture and Home Furnishings Manufacturing",
    countCompanies: 174873,
  },
  {
    label: "Civil Engineering",
    countCompanies: 169738,
  },
  {
    label: "Primary and Secondary Education",
    countCompanies: 169124,
  },
  {
    label: "Medical Equipment Manufacturing",
    countCompanies: 152602,
  },
  {
    label: "Textile Manufacturing",
    countCompanies: 151569,
  },
  {
    label: "Renewable Energy Semiconductor Manufacturing",
    countCompanies: 149013,
  },
  {
    label: "Public Relations and Communications Services",
    countCompanies: 143862,
  },
  {
    label: "Online Audio and Video Media",
    countCompanies: 140302,
  },
  {
    label: "Printing Services",
    countCompanies: 139606,
  },
  {
    label: "Religious Institutions",
    countCompanies: 139517,
  },
  {
    label: "Performing Arts",
    countCompanies: 137817,
  },
  {
    label: "Mental Health Care",
    countCompanies: 137800,
  },
  {
    label: "Personal Care Product Manufacturing",
    countCompanies: 133405,
  },
  {
    label: "International Trade and Development",
    countCompanies: 130842,
  },
  {
    label: "Information Services",
    countCompanies: 128992,
  },
  {
    label: "Chemical Manufacturing",
    countCompanies: 128110,
  },
  {
    label: "Health, Wellness and Fitness",
    countCompanies: 126664,
  },
  {
    label: "Pharmaceutical Manufacturing",
    countCompanies: 126152,
  },
  {
    label: "Utilities",
    countCompanies: 122507,
  },
  {
    label: "Movies, Videos and Sound",
    countCompanies: 118745,
  },
  {
    label: "Wholesale Import and Export",
    countCompanies: 116945,
  },
  {
    label: "Broadcast Media Production and Distribution",
    countCompanies: 116680,
  },
  {
    label: "Security and Investigations",
    countCompanies: 116567,
  },
  {
    label: "Retail Art Supplies",
    countCompanies: 101947,
  },
  {
    label: "Banking",
    countCompanies: 101284,
  },
  {
    label: "Biotechnology Research",
    countCompanies: 98159,
  },
  {
    label: "Recreational Facilities",
    countCompanies: 96948,
  },
  {
    label: "Automation Machinery Manufacturing",
    countCompanies: 93237,
  },
  {
    label: "Retail Luxury Goods and Jewelry",
    countCompanies: 92379,
  },
  {
    label: "Writing and Editing",
    countCompanies: 88322,
  },
  {
    label: "Plastics Manufacturing",
    countCompanies: 87722,
  },
  {
    label: "Computers and Electronics Manufacturing",
    countCompanies: 86510,
  },
  {
    label: "Artists and Writers",
    countCompanies: 84683,
  },
  {
    label: "Retail Groceries",
    countCompanies: 83364,
  },
  {
    label: "Automotive",
    countCompanies: 81707,
  },
  {
    label: "Education Management",
    countCompanies: 80788,
  },
  {
    label: "Freight and Package Transportation",
    countCompanies: 80589,
  },
  {
    label: "Food \u0026 Beverages",
    countCompanies: 80394,
  },
  {
    label: "Non-profit Organization Management",
    countCompanies: 78324,
  },
  {
    label: "Computer and Network Security",
    countCompanies: 74095,
  },
  {
    label: "Technology, Information and Media",
    countCompanies: 73580,
  },
  {
    label: "Computer Games",
    countCompanies: 73247,
  },
  {
    label: "Leasing Non-residential Real Estate",
    countCompanies: 72211,
  },
  {
    label: "Design",
    countCompanies: 70722,
  },
  {
    label: "Airlines and Aviation",
    countCompanies: 69950,
  },
  {
    label: "Veterinary Services",
    countCompanies: 69227,
  },
  {
    label: "Beverage Manufacturing",
    countCompanies: 66652,
  },
  {
    label: "Maritime Transportation",
    countCompanies: 66558,
  },
  {
    label: "Executive Offices",
    countCompanies: 64885,
  },
  {
    label: "Engineering Services",
    countCompanies: 62943,
  },
  {
    label: "Market Research",
    countCompanies: 61685,
  },
  {
    label: "Paper and Forest Product Manufacturing",
    countCompanies: 61325,
  },
  {
    label: "Packaging and Containers Manufacturing",
    countCompanies: 60980,
  },
  {
    label: "Transportation/Trucking/Railroad",
    countCompanies: 58928,
  },
  {
    label: "Outsourcing and Offshoring Consulting",
    countCompanies: 56324,
  },
  {
    label: "Sporting Goods Manufacturing",
    countCompanies: 55728,
  },
  {
    label: "Apparel and Fashion",
    countCompanies: 55194,
  },
  {
    label: "Strategic Management Services",
    countCompanies: 54990,
  },
  {
    label: "Mechanical or Industrial Engineering",
    countCompanies: 54806,
  },
  {
    label: "Food Production",
    countCompanies: 54374,
  },
  {
    label: "Entertainment",
    countCompanies: 54305,
  },
  {
    label: "Aviation and Aerospace Component Manufacturing",
    countCompanies: 53354,
  },
  {
    label: "Leisure, Travel \u0026 Tourism",
    countCompanies: 52391,
  },
  {
    label: "Consumer Goods",
    countCompanies: 51764,
  },
  {
    label: "Museums, Historical Sites, and Zoos",
    countCompanies: 48702,
  },
  {
    label: "Investment Banking",
    countCompanies: 48060,
  },
  {
    label: "Health and Human Services",
    countCompanies: 46793,
  },
  {
    label: "Philanthropic Fundraising Services",
    countCompanies: 43356,
  },
  {
    label: "Human Resources",
    countCompanies: 42389,
  },
  {
    label: "Computer Hardware Manufacturing",
    countCompanies: 40916,
  },
  {
    label: "E-Learning",
    countCompanies: 40819,
  },
  {
    label: "Translation and Localization",
    countCompanies: 38843,
  },
  {
    label: "Research",
    countCompanies: 38198,
  },
  {
    label: "Public Safety",
    countCompanies: 37718,
  },
  {
    label: "Newspaper Publishing",
    countCompanies: 37015,
  },
  {
    label: "Business Supplies and Equipment",
    countCompanies: 36853,
  },
  {
    label: "Defense and Space Manufacturing",
    countCompanies: 36834,
  },
  {
    label: "Interior Design",
    countCompanies: 36737,
  },
  {
    label: "Glass, Ceramics and Concrete Manufacturing",
    countCompanies: 35897,
  },
  {
    label: "Computer Networking Products",
    countCompanies: 35756,
  },
  {
    label: "Alternative Medicine",
    countCompanies: 34332,
  },
  {
    label: "Warehousing and Storage",
    countCompanies: 34175,
  },
  {
    label: "Think Tanks",
    countCompanies: 33177,
  },
  {
    label: "Animation and Post-production",
    countCompanies: 33027,
  },
  {
    label: "Building Materials",
    countCompanies: 32708,
  },
  {
    label: "Capital Markets",
    countCompanies: 31128,
  },
  {
    label: "Furniture",
    countCompanies: 30846,
  },
  {
    label: "Ranching",
    countCompanies: 30809,
  },
  {
    label: "Semiconductor Manufacturing",
    countCompanies: 30615,
  },
  {
    label: "Sports Teams and Clubs",
    countCompanies: 30535,
  },
  {
    label: "Music",
    countCompanies: 30084,
  },
  {
    label: "IT System Custom Software Development",
    countCompanies: 29772,
  },
  {
    label: "Political Organizations",
    countCompanies: 29539,
  },
  {
    label: "Retail Health and Personal Care Products",
    countCompanies: 29177,
  },
  {
    label: "Services for Renewable Energy",
    countCompanies: 28262,
  },
  {
    label: "Professional Services",
    countCompanies: 28150,
  },
  {
    label: "Medical Devices",
    countCompanies: 28141,
  },
  {
    label: "Fundraising",
    countCompanies: 27742,
  },
  {
    label: "Government Relations Services",
    countCompanies: 27348,
  },
  {
    label: "Cosmetics",
    countCompanies: 26571,
  },
  {
    label: "Law Enforcement",
    countCompanies: 26341,
  },
  {
    label: "Wireless Services",
    countCompanies: 25186,
  },
  {
    label: "Renewables \u0026 Environment",
    countCompanies: 25094,
  },
  {
    label: "International Affairs",
    countCompanies: 24168,
  },
  {
    label: "Internet Publishing",
    countCompanies: 23607,
  },
  {
    label: "Social Networking Platforms",
    countCompanies: 22970,
  },
  {
    label: "Online Media",
    countCompanies: 22914,
  },
  {
    label: "Arts and Crafts",
    countCompanies: 20532,
  },
  {
    label: "Internet Marketplace Platforms",
    countCompanies: 20064,
  },
  {
    label: "Public Policy Offices",
    countCompanies: 20031,
  },
  {
    label: "Public Health",
    countCompanies: 19285,
  },
  {
    label: "Real Estate Agents and Brokers",
    countCompanies: 19227,
  },
  {
    label: "Technical and Vocational Training",
    countCompanies: 18713,
  },
  {
    label: "Community Services",
    countCompanies: 18465,
  },
  {
    label: "Dairy Product Manufacturing",
    countCompanies: 18294,
  },
  {
    label: "Armed Forces",
    countCompanies: 18161,
  },
  {
    label: "Internet News",
    countCompanies: 18025,
  },
  {
    label: "Building Construction",
    countCompanies: 17968,
  },
  {
    label: "Solar Electric Power Generation",
    countCompanies: 17911,
  },
  {
    label: "Gambling Facilities and Casinos",
    countCompanies: 17594,
  },
  {
    label: "Food and Beverage Retail",
    countCompanies: 17460,
  },
  {
    label: "Online and Mail Order Retail",
    countCompanies: 17203,
  },
  {
    label: "Data Infrastructure and Analytics",
    countCompanies: 17194,
  },
  {
    label: "Retail Motor Vehicles",
    countCompanies: 17076,
  },
  {
    label: "Blockchain Services",
    countCompanies: 16687,
  },
  {
    label: "Consumer Electronics",
    countCompanies: 16609,
  },
  {
    label: "Import and Export",
    countCompanies: 16568,
  },
  {
    label: "Shipbuilding",
    countCompanies: 16275,
  },
  {
    label: "Biotechnology",
    countCompanies: 15956,
  },
  {
    label: "Sports and Recreation Instruction",
    countCompanies: 15935,
  },
  {
    label: "Industrial Automation",
    countCompanies: 15726,
  },
  {
    label: "Luxury Goods and Jewelry",
    countCompanies: 15704,
  },
  {
    label: "Agriculture, Construction, Mining Machinery Manufacturing",
    countCompanies: 15677,
  },
  {
    label: "Libraries",
    countCompanies: 15389,
  },
  {
    label: "Home Health Care Services",
    countCompanies: 15321,
  },
  {
    label: "Fisheries",
    countCompanies: 15030,
  },
  {
    label: "Business Content",
    countCompanies: 14723,
  },
  {
    label: "Vehicle Repair and Maintenance",
    countCompanies: 14716,
  },
  {
    label: "Operations Consulting",
    countCompanies: 14685,
  },
  {
    label: "Insurance Agencies and Brokerages",
    countCompanies: 14459,
  },
  {
    label: "Administration of Justice",
    countCompanies: 14286,
  },
  {
    label: "Fine Art",
    countCompanies: 13649,
  },
  {
    label: "Repair and Maintenance",
    countCompanies: 13468,
  },
  {
    label: "Blogs",
    countCompanies: 13380,
  },
  {
    label: "Wine and Spirits",
    countCompanies: 13107,
  },
  {
    label: "Renewable Energy Power Generation",
    countCompanies: 12960,
  },
  {
    label: "Paper and Forest Products",
    countCompanies: 12948,
  },
  {
    label: "Media \u0026 Telecommunications",
    countCompanies: 12859,
  },
  {
    label: "Veterinary",
    countCompanies: 12837,
  },
  {
    label: "Industry Associations",
    countCompanies: 12280,
  },
  {
    label: "Security Systems Services",
    countCompanies: 12100,
  },
  {
    label: "Landscaping Services",
    countCompanies: 11647,
  },
  {
    label: "Holding Companies",
    countCompanies: 11555,
  },
  {
    label: "Retail Furniture and Home Furnishings",
    countCompanies: 11551,
  },
  {
    label: "Pet Services",
    countCompanies: 11527,
  },
  {
    label: "Commercial Real Estate",
    countCompanies: 11338,
  },
  {
    label: "Dentists",
    countCompanies: 11123,
  },
  {
    label: "Wholesale Food and Beverage",
    countCompanies: 11087,
  },
  {
    label: "Fabricated Metal Products",
    countCompanies: 10777,
  },
  {
    label: "Maritime",
    countCompanies: 10348,
  },
  {
    label: "Apparel Manufacturing",
    countCompanies: 10260,
  },
  {
    label: "Administrative and Support Services",
    countCompanies: 10256,
  },
  {
    label: "Book Publishing",
    countCompanies: 10231,
  },
  {
    label: "Packaging and Containers",
    countCompanies: 10126,
  },
  {
    label: "Hotels and Motels",
    countCompanies: 10064,
  },
  {
    label: "Specialty Trade Contractors",
    countCompanies: 9952,
  },
  {
    label: "Janitorial Services",
    countCompanies: 9761,
  },
  {
    label: "Commercial and Industrial Machinery Maintenance",
    countCompanies: 9678,
  },
  {
    label: "Mobile Gaming Apps",
    countCompanies: 9598,
  },
  {
    label: "Tobacco Manufacturing",
    countCompanies: 9553,
  },
  {
    label: "Sporting Goods",
    countCompanies: 9399,
  },
  {
    label: "Alternative Dispute Resolution",
    countCompanies: 9347,
  },
  {
    label: "Professional Organizations",
    countCompanies: 9255,
  },
  {
    label: "Digital Accessibility Services",
    countCompanies: 9149,
  },
  {
    label: "Physical, Occupational and Speech Therapists",
    countCompanies: 8992,
  },
  {
    label: "Residential Building Construction",
    countCompanies: 8865,
  },
  {
    label: "Personal Care Services",
    countCompanies: 8851,
  },
  {
    label: "Aviation \u0026 Aerospace",
    countCompanies: 8751,
  },
  {
    label: "Medical and Diagnostic Laboratories",
    countCompanies: 8747,
  },
  {
    label: "Outsourcing/Offshoring",
    countCompanies: 8513,
  },
  {
    label: "Language Schools",
    countCompanies: 8472,
  },
  {
    label: "Railroad Equipment Manufacturing",
    countCompanies: 8402,
  },
  {
    label: "Nanotechnology Research",
    countCompanies: 8119,
  },
  {
    label: "Computer Hardware",
    countCompanies: 7570,
  },
  {
    label: "Fashion Accessories Manufacturing",
    countCompanies: 7485,
  },
  {
    label: "Business Intelligence Platforms",
    countCompanies: 7421,
  },
  {
    label: "Wholesale Motor Vehicles and Parts",
    countCompanies: 7275,
  },
  {
    label: "HVAC and Refrigeration Equipment Manufacturing",
    countCompanies: 7216,
  },
  {
    label: "Mobile Computing Software Products",
    countCompanies: 7130,
  },
  {
    label: "Philanthropy",
    countCompanies: 7045,
  },
  {
    label: "Retail Appliances, Electrical, and Electronic Equipment",
    countCompanies: 6913,
  },
  {
    label: "Program Development",
    countCompanies: 6883,
  },
  {
    label: "Investment Advice",
    countCompanies: 6880,
  },
  {
    label: "IT System Data Services",
    countCompanies: 6817,
  },
  {
    label: "Electric Power Transmission, Control, and Distribution",
    countCompanies: 6530,
  },
  {
    label: "Motor Vehicle Parts Manufacturing",
    countCompanies: 6419,
  },
  {
    label: "Retail Art Dealers",
    countCompanies: 6394,
  },
  {
    label: "Security Guards and Patrol Services",
    countCompanies: 6317,
  },
  {
    label: "Fire Protection",
    countCompanies: 6255,
  },
  {
    label: "Wood Product Manufacturing",
    countCompanies: 6219,
  },
  {
    label: "Real Estate and Equipment Rental Services",
    countCompanies: 6147,
  },
  {
    label: "Computer Networking",
    countCompanies: 6141,
  },
  {
    label: "Semiconductors",
    countCompanies: 6023,
  },
  {
    label: "Defense \u0026 Space",
    countCompanies: 5908,
  },
  {
    label: "Electrical Equipment Manufacturing",
    countCompanies: 5890,
  },
  {
    label: "IT System Design Services",
    countCompanies: 5727,
  },
  {
    label: "Wineries",
    countCompanies: 5723,
  },
  {
    label: "Wholesale Appliances, Electrical, and Electronics",
    countCompanies: 5714,
  },
  {
    label: "Retail Office Supplies and Gifts",
    countCompanies: 5706,
  },
  {
    label: "Warehousing",
    countCompanies: 5618,
  },
  {
    label: "Caterers",
    countCompanies: 5586,
  },
  {
    label: "Embedded Software Products",
    countCompanies: 5543,
  },
  {
    label: "Farming, Ranching, Forestry",
    countCompanies: 5518,
  },
  {
    label: "Renewable Energy Equipment Manufacturing",
    countCompanies: 5514,
  },
  {
    label: "Equipment Rental Services",
    countCompanies: 5507,
  },
  {
    label: "Leasing Residential Real Estate",
    countCompanies: 5423,
  },
  {
    label: "Robotics Engineering",
    countCompanies: 5306,
  },
  {
    label: "Space Research and Technology",
    countCompanies: 4990,
  },
  {
    label: "Ground Passenger Transportation",
    countCompanies: 4955,
  },
  {
    label: "Community Development and Urban Planning",
    countCompanies: 4810,
  },
  {
    label: "Building Finishing Contractors",
    countCompanies: 4727,
  },
  {
    label: "Electric Lighting Equipment Manufacturing",
    countCompanies: 4654,
  },
  {
    label: "Oil, Gas, and Mining",
    countCompanies: 4645,
  },
  {
    label: "IT System Training and Support",
    countCompanies: 4641,
  },
  {
    label: "Wholesale Hardware, Plumbing, Heating Equipment",
    countCompanies: 4623,
  },
  {
    label: "Housing and Community Development",
    countCompanies: 4595,
  },
  {
    label: "Retail Pharmacies",
    countCompanies: 4548,
  },
  {
    label: "Movies and Sound Recording",
    countCompanies: 4526,
  },
  {
    label: "Government Relations",
    countCompanies: 4507,
  },
  {
    label: "Wholesale Chemical and Allied Products",
    countCompanies: 4438,
  },
  {
    label: "Child Day Care Services",
    countCompanies: 4394,
  },
  {
    label: "Building Structure and Exterior Contractors",
    countCompanies: 4352,
  },
  {
    label: "Paint, Coating, and Adhesive Manufacturing",
    countCompanies: 4333,
  },
  {
    label: "Radio and Television Broadcasting",
    countCompanies: 4312,
  },
  {
    label: "Desktop Computing Software Products",
    countCompanies: 4274,
  },
  {
    label: "Animation",
    countCompanies: 4164,
  },
  {
    label: "Accessible Architecture and Design",
    countCompanies: 4106,
  },
  {
    label: "Electric Power Generation",
    countCompanies: 3961,
  },
  {
    label: "Services for the Elderly and Disabled",
    countCompanies: 3946,
  },
  {
    label: "Wholesale Luxury Goods and Jewelry",
    countCompanies: 3944,
  },
  {
    label: "Wholesale Machinery",
    countCompanies: 3932,
  },
  {
    label: "Retail Building Materials and Garden Equipment",
    countCompanies: 3931,
  },
  {
    label: "Waste Treatment and Disposal",
    countCompanies: 3885,
  },
  {
    label: "Footwear Manufacturing",
    countCompanies: 3877,
  },
  {
    label: "Nursing Homes and Residential Care Facilities",
    countCompanies: 3833,
  },
  {
    label: "Building Equipment Contractors",
    countCompanies: 3812,
  },
  {
    label: "Metal Treatments",
    countCompanies: 3796,
  },
  {
    label: "Wholesale Alcoholic Beverages",
    countCompanies: 3777,
  },
  {
    label: "Accommodation Services",
    countCompanies: 3726,
  },
  {
    label: "Commercial and Service Industry Machinery Manufacturing",
    countCompanies: 3693,
  },
  {
    label: "Horticulture",
    countCompanies: 3634,
  },
  {
    label: "Periodical Publishing",
    countCompanies: 3625,
  },
  {
    label: "Agricultural Chemical Manufacturing",
    countCompanies: 3623,
  },
  {
    label: "Water Supply and Irrigation Systems",
    countCompanies: 3577,
  },
  {
    label: "Architectural and Structural Metal Manufacturing",
    countCompanies: 3563,
  },
  {
    label: "Household Services",
    countCompanies: 3555,
  },
  {
    label: "Data Security Software Products",
    countCompanies: 3526,
  },
  {
    label: "Executive Search Services",
    countCompanies: 3503,
  },
  {
    label: "Commercial and Industrial Equipment Rental",
    countCompanies: 3478,
  },
  {
    label: "Telephone Call Centers",
    countCompanies: 3386,
  },
  {
    label: "Baked Goods Manufacturing",
    countCompanies: 3366,
  },
  {
    label: "Waste Collection",
    countCompanies: 3361,
  },
  {
    label: "Mobile Food Services",
    countCompanies: 3287,
  },
  {
    label: "Bars, Taverns, and Nightclubs",
    countCompanies: 3279,
  },
  {
    label: "Office Furniture and Fixtures Manufacturing",
    countCompanies: 3275,
  },
  {
    label: "Museums",
    countCompanies: 3221,
  },
  {
    label: "Taxi and Limousine Services",
    countCompanies: 3204,
  },
  {
    label: "Public Policy",
    countCompanies: 3144,
  },
  {
    label: "Climate Technology Product Manufacturing",
    countCompanies: 3126,
  },
  {
    label: "Conservation Programs",
    countCompanies: 3101,
  },
  {
    label: "Sightseeing Transportation",
    countCompanies: 2986,
  },
  {
    label: "Retail Florists",
    countCompanies: 2930,
  },
  {
    label: "Golf Courses and Country Clubs",
    countCompanies: 2929,
  },
  {
    label: "Loan Brokers",
    countCompanies: 2865,
  },
  {
    label: "Office Administration",
    countCompanies: 2860,
  },
  {
    label: "Metalworking Machinery Manufacturing",
    countCompanies: 2829,
  },
  {
    label: "Surveying and Mapping Services",
    countCompanies: 2821,
  },
  {
    label: "Plastics and Rubber Product Manufacturing",
    countCompanies: 2768,
  },
  {
    label: "Sound Recording",
    countCompanies: 2698,
  },
  {
    label: "Physicians",
    countCompanies: 2693,
  },
  {
    label: "Water, Waste, Steam, and Air Conditioning Services",
    countCompanies: 2673,
  },
  {
    label: "Cosmetology and Barber Schools",
    countCompanies: 2633,
  },
  {
    label: "Retail Books and Printed News",
    countCompanies: 2593,
  },
  {
    label: "Dairy",
    countCompanies: 2578,
  },
  {
    label: "Glass Product Manufacturing",
    countCompanies: 2575,
  },
  {
    label: "Air, Water, and Waste Program Management",
    countCompanies: 2551,
  },
  {
    label: "Construction Hardware Manufacturing",
    countCompanies: 2547,
  },
  {
    label: "Wholesale Metals and Minerals",
    countCompanies: 2506,
  },
  {
    label: "Rail Transportation",
    countCompanies: 2480,
  },
  {
    label: "Soap and Cleaning Product Manufacturing",
    countCompanies: 2469,
  },
  {
    label: "Measuring and Control Instrument Manufacturing",
    countCompanies: 2451,
  },
  {
    label: "IT System Operations and Maintenance",
    countCompanies: 2421,
  },
  {
    label: "Animal Feed Manufacturing",
    countCompanies: 2353,
  },
  {
    label: "Fine Arts Schools",
    countCompanies: 2337,
  },
  {
    label: "Leather Product Manufacturing",
    countCompanies: 2331,
  },
  {
    label: "Bed-and-Breakfasts, Hostels, Homestays",
    countCompanies: 2315,
  },
  {
    label: "Wholesale Furniture and Home Furnishings",
    countCompanies: 2309,
  },
  {
    label: "Electronic and Precision Equipment Maintenance",
    countCompanies: 2304,
  },
  {
    label: "Wholesale Raw Farm Products",
    countCompanies: 2280,
  },
  {
    label: "Chemical Raw Materials Manufacturing",
    countCompanies: 2186,
  },
  {
    label: "Wholesale Recyclable Materials",
    countCompanies: 2133,
  },
  {
    label: "Wholesale Drugs and Sundries",
    countCompanies: 2126,
  },
  {
    label: "Theater Companies",
    countCompanies: 2113,
  },
  {
    label: "Laundry and Drycleaning Services",
    countCompanies: 2094,
  },
  {
    label: "Transportation Programs",
    countCompanies: 2086,
  },
  {
    label: "Wholesale Apparel and Sewing Supplies",
    countCompanies: 2078,
  },
  {
    label: "Wholesale Computer Equipment",
    countCompanies: 2064,
  },
  {
    label: "Legislative Offices",
    countCompanies: 2064,
  },
  {
    label: "Forestry and Logging",
    countCompanies: 2023,
  },
  {
    label: "Primary Metal Manufacturing",
    countCompanies: 2007,
  },
  {
    label: "Environmental Quality Programs",
    countCompanies: 1923,
  },
  {
    label: "Highway, Street, and Bridge Construction",
    countCompanies: 1918,
  },
  {
    label: "Breweries",
    countCompanies: 1900,
  },
  {
    label: "Optometrists",
    countCompanies: 1897,
  },
  {
    label: "Performing Arts and Spectator Sports",
    countCompanies: 1887,
  },
  {
    label: "Wholesale Petroleum and Petroleum Products",
    countCompanies: 1867,
  },
  {
    label: "Emergency and Relief Services",
    countCompanies: 1864,
  },
  {
    label: "Audio and Video Equipment Manufacturing",
    countCompanies: 1856,
  },
  {
    label: "Dance Companies",
    countCompanies: 1847,
  },
  {
    label: "Economic Programs",
    countCompanies: 1823,
  },
  {
    label: "Consumer Goods Rental",
    countCompanies: 1783,
  },
  {
    label: "Funds and Trusts",
    countCompanies: 1736,
  },
  {
    label: "Household and Institutional Furniture Manufacturing",
    countCompanies: 1701,
  },
  {
    label: "Climate Data and Analytics",
    countCompanies: 1680,
  },
  {
    label: "Retail Recyclable Materials \u0026 Used Merchandise",
    countCompanies: 1665,
  },
  {
    label: "Tobacco",
    countCompanies: 1635,
  },
  {
    label: "Urban Transit Services",
    countCompanies: 1617,
  },
  {
    label: "Utility System Construction",
    countCompanies: 1597,
  },
  {
    label: "Chiropractors",
    countCompanies: 1533,
  },
  {
    label: "Meat Products Manufacturing",
    countCompanies: 1509,
  },
  {
    label: "IT System Testing and Evaluation",
    countCompanies: 1454,
  },
  {
    label: "Wholesale Paper Products",
    countCompanies: 1406,
  },
  {
    label: "Trusts and Estates",
    countCompanies: 1399,
  },
  {
    label: "Amusement Parks and Arcades",
    countCompanies: 1375,
  },
  {
    label: "Military and International Affairs",
    countCompanies: 1369,
  },
  {
    label: "Personal and Laundry Services",
    countCompanies: 1358,
  },
  {
    label: "Shuttles and Special Needs Transportation Services",
    countCompanies: 1347,
  },
  {
    label: "Vocational Rehabilitation Services",
    countCompanies: 1343,
  },
  {
    label: "Retail Musical Instruments",
    countCompanies: 1255,
  },
  {
    label: "Temporary Help Services",
    countCompanies: 1238,
  },
  {
    label: "Telecommunications Carriers",
    countCompanies: 1169,
  },
  {
    label: "Rubber Products Manufacturing",
    countCompanies: 1167,
  },
  {
    label: "Distilleries",
    countCompanies: 1122,
  },
  {
    label: "Insurance and Employee Benefit Funds",
    countCompanies: 1116,
  },
  {
    label: "Sugar and Confectionery Product Manufacturing",
    countCompanies: 1091,
  },
  {
    label: "Steam and Air-Conditioning Supply",
    countCompanies: 1090,
  },
  {
    label: "Communications Equipment Manufacturing",
    countCompanies: 1079,
  },
  {
    label: "Nonresidential Building Construction",
    countCompanies: 1078,
  },
  {
    label: "Turned Products and Fastener Manufacturing",
    countCompanies: 1021,
  },
  {
    label: "Seafood Product Manufacturing",
    countCompanies: 957,
  },
  {
    label: "Hospitals",
    countCompanies: 953,
  },
  {
    label: "Collection Agencies",
    countCompanies: 941,
  },
  {
    label: "Engines and Power Transmission Equipment Manufacturing",
    countCompanies: 936,
  },
  {
    label: "Transportation Equipment Manufacturing",
    countCompanies: 923,
  },
  {
    label: "Wind Electric Power Generation",
    countCompanies: 905,
  },
  {
    label: "Robot Manufacturing",
    countCompanies: 869,
  },
  {
    label: "Household Appliance Manufacturing",
    countCompanies: 866,
  },
  {
    label: "Utilities Administration",
    countCompanies: 852,
  },
  {
    label: "Wholesale Footwear",
    countCompanies: 800,
  },
  {
    label: "Credit Intermediation",
    countCompanies: 773,
  },
  {
    label: "Metal Ore Mining",
    countCompanies: 747,
  },
  {
    label: "Housing Programs",
    countCompanies: 744,
  },
  {
    label: "Public Assistance Programs",
    countCompanies: 732,
  },
  {
    label: "Fruit and Vegetable Preserves Manufacturing",
    countCompanies: 717,
  },
  {
    label: "Sheet Music Publishing",
    countCompanies: 703,
  },
  {
    label: "Securities and Commodity Exchanges",
    countCompanies: 698,
  },
  {
    label: "Regenerative Design",
    countCompanies: 696,
  },
  {
    label: "Historical Sites",
    countCompanies: 695,
  },
  {
    label: "Insurance Carriers",
    countCompanies: 682,
  },
  {
    label: "Flight Training",
    countCompanies: 665,
  },
  {
    label: "Zoos and Botanical Gardens",
    countCompanies: 645,
  },
  {
    label: "Courts of Law",
    countCompanies: 642,
  },
  {
    label: "Boilers, Tanks, and Shipping Container Manufacturing",
    countCompanies: 640,
  },
  {
    label: "Mattress and Blinds Manufacturing",
    countCompanies: 633,
  },
  {
    label: "Claims Adjusting, Actuarial Services",
    countCompanies: 633,
  },
  {
    label: "Ambulance Services",
    countCompanies: 618,
  },
  {
    label: "Satellite Telecommunications",
    countCompanies: 603,
  },
  {
    label: "Outpatient Care Centers",
    countCompanies: 577,
  },
  {
    label: "Retail Gasoline",
    countCompanies: 569,
  },
  {
    label: "Nuclear Electric Power Generation",
    countCompanies: 561,
  },
  {
    label: "IT System Installation and Disposal",
    countCompanies: 555,
  },
  {
    label: "Natural Gas Distribution",
    countCompanies: 554,
  },
  {
    label: "Coal Mining",
    countCompanies: 523,
  },
  {
    label: "School and Employee Bus Services",
    countCompanies: 508,
  },
  {
    label: "Metal Valve, Ball, and Roller Manufacturing",
    countCompanies: 452,
  },
  {
    label: "Reupholstery and Furniture Repair",
    countCompanies: 444,
  },
  {
    label: "Biomass Electric Power Generation",
    countCompanies: 415,
  },
  {
    label: "Spring and Wire Product Manufacturing",
    countCompanies: 403,
  },
  {
    label: "Nonmetallic Mineral Mining",
    countCompanies: 393,
  },
  {
    label: "Hydroelectric Power Generation",
    countCompanies: 385,
  },
  {
    label: "Alternative Fuel Vehicle Manufacturing",
    countCompanies: 379,
  },
  {
    label: "Abrasives and Nonmetallic Minerals Manufacturing",
    countCompanies: 360,
  },
  {
    label: "Women\u0027s Handbag Manufacturing",
    countCompanies: 351,
  },
  {
    label: "Wholesale Photography Equipment and Supplies",
    countCompanies: 347,
  },
  {
    label: "Clay and Refractory Products Manufacturing",
    countCompanies: 335,
  },
  {
    label: "Ranching and Fisheries",
    countCompanies: 329,
  },
  {
    label: "Cutlery and Handtool Manufacturing",
    countCompanies: 327,
  },
  {
    label: "Oil Extraction",
    countCompanies: 306,
  },
  {
    label: "Subdivision of Land",
    countCompanies: 297,
  },
  {
    label: "Pipeline Transportation",
    countCompanies: 295,
  },
  {
    label: "Racetracks",
    countCompanies: 284,
  },
  {
    label: "Postal Services",
    countCompanies: 282,
  },
  {
    label: "Accessible Hardware Manufacturing",
    countCompanies: 253,
  },
  {
    label: "Pension Funds",
    countCompanies: 251,
  },
  {
    label: "Skiing Facilities",
    countCompanies: 239,
  },
  {
    label: "Footwear and Leather Goods Repair",
    countCompanies: 239,
  },
  {
    label: "Fossil Fuel Electric Power Generation",
    countCompanies: 232,
  },
  {
    label: "Geothermal Electric Power Generation",
    countCompanies: 232,
  },
  {
    label: "Oil and Coal Product Manufacturing",
    countCompanies: 224,
  },
  {
    label: "Magnetic and Optical Media Manufacturing",
    countCompanies: 190,
  },
  {
    label: "Interurban and Rural Bus Services",
    countCompanies: 183,
  },
  {
    label: "Circuses and Magic Shows",
    countCompanies: 157,
  },
  {
    label: "Correctional Institutions",
    countCompanies: 139,
  },
  {
    label: "Artificial Rubber and Synthetic Fiber Manufacturing",
    countCompanies: 133,
  },
  {
    label: "Energy Technology",
    countCompanies: 127,
  },
  {
    label: "Smart Meter Manufacturing",
    countCompanies: 126,
  },
  {
    label: "Cable and Satellite Programming",
    countCompanies: 115,
  },
  {
    label: "Fuel Cell Manufacturing",
    countCompanies: 108,
  },
  {
    label: "Lime and Gypsum Products Manufacturing",
    countCompanies: 106,
  },
  {
    label: "Secretarial Schools",
    countCompanies: 100,
  },
  {
    label: "Natural Gas Extraction",
    countCompanies: 93,
  },
  {
    label: "Savings Institutions",
    countCompanies: 79,
  },
  {
    label: "Family Planning Centers",
    countCompanies: 69,
  },
];
